import { DataService } from './dataService'

const AttributeAdditionalService = {
	getAttributeadditionalfees: async(data) => {
		return DataService.get('/admin/attribute_additional_charges', data)
	},
	addAttributeadditionalfees: async (data) => {
		return DataService.post('/admin/attribute_additional_charges', data)
	},
}

export default AttributeAdditionalService